/* eslint-disable react/jsx-indent */
import React from "react";

import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import { AI_PROMPT_TYPE } from "app/utils/constants";

type PostStoryModalButtonProps = {
  points?: number;
  onOpen: () => void;
  buttonText?: React.ReactNode;
};

const PostStoryModalButton: React.FC<PostStoryModalButtonProps> = (
  { points, onOpen, buttonText }) => (
  <Button onClick={onOpen}>
    {buttonText || (
      AI_PROMPT_TYPE ? (
        <>
          <Trans>Let&apos;s get started</Trans>
          <Icon className="arrow-icon" icon="arrow-left-c" />
        </>
      ) : (
        <Trans>Add your story! +{points ?? 50}</Trans>
      )
    )}
  </Button>
);

export default PostStoryModalButton;
